/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import { Dialog } from '@progress/kendo-react-dialogs'
import { FindIcon, ShareVaultIcon, DeleteIcon } from 'assets'
import Tooltip from '@mui/material/Tooltip'
import LoadingOverlay from 'components/Common/Overlay/LoadingOverlay'
import ConfirmDialog from 'components/Common/Dialog/ConfirmDialog'
import VaultAddDocumentPopUp from 'components/Vault/VaultAddDocumentPopUp'
import VaultDocumentPreviewPopup from 'components/Vault/VaultDocumentPreviewPopup'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import actionTypes from 'store/actions'

import { VaultAPI } from 'api'
import Button from 'components/Common/Button'
import { PRIMARY_BUTTON } from 'themes/theme'
import ShareModal from '../VaultBOD/shareModal'
import { Typography, Box } from '@mui/material'

const sx = {
  tableBox: {
    height: '500px',
    width: '100%',
    marginTop: '30px',
  },

  table: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '10px 0',
    color: '#66668F',
    border: 'none',
    boxShadow: '4px 4px 15px rgba(10, 120, 205, 0.08)',

    img: {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },

    '.MuiDataGrid-cell, .MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
      whiteSpace: 'normal !important',
      wordBreak: 'break-all !important',
    },

    '.MuiDataGrid-columnHeaders': {
      color: '#25245F',
    },

    '.MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },

    '.MuiCheckbox-root': {
      color: '#BDBDCE',
    },

    '.MuiDataGrid-sortIcon': {
      color: '#25245F',
      opacity: 'inherit !important',
    },

    '& .MuiDataGrid-iconButtonContainer': {
      visibility: 'visible !important',
    },

    '.MuiDataGrid-overlay': {
      zIndex: '0',
    },
  },

  tooltip: {
    fontSize: '12px',
    backgroundColor: '#0A78CD',

    '.MuiTooltip-arrow': {
      color: '#0A78CD',
    },
  },
}

const VaultDocuments = () => {
  const dispatch = useDispatch()
  const loadingVaultSummary = useSelector(state => state.vaultReducer.loadingVaultSummary)
  const vaultInfo = useSelector(state => state.vaultReducer.vaultSummary)
  // const vaultInfo = useSelector(state => state.apiResponseReducers.dashboardInfo?.vault_info)

  //TODO: Once API is implemented and use actucal documents and loading status.
  const documents = useSelector(state => state.vaultReducer.documents)
  const loadingDocuments = useSelector(state => state.vaultReducer.loadingDocuments)

  //NOTE: For removing selected documents
  const [selectedDocuments, setSelectedDocuments] = useState([])
  //NOTE: For removing one document
  const [selectedPreview, setSelectedPreview] = useState(null)
  const [selectedToRemove, setSelectedToRemove] = useState([])
  const [showAddDocumentPopup, setShowAddDocumentPopup] = useState(false)
  const [showRemoveConfirmPopup, setShowRemoveConfirmPopup] = useState(false)
  const [previewDialog, setPreviewDialog] = useState(false)
  const [showSharePopup, setShowSharePopup] = useState(false)
  const [selectedDatum, setDatum] = useState(false)

  useEffect(() => {
    if (!vaultInfo.vault_id) {
      return
    }
    if (!loadingVaultSummary) VaultAPI.fetchDocuments(dispatch, vaultInfo.vault_id)
  }, [vaultInfo.vault_id])

  const columns = [
    {
      field: 'article_name',
      headerName: 'File Name',
      sortable: true,
      width: 175,
    },
    {
      field: 'article_category',
      headerName: 'Document Type',
      sortable: true,
      width: 195,
    },
    {
      field: 'article_description',
      headerName: 'Description',
      sortable: true,
      width: 260,
    },
    {
      field: 'Uploaded On',
      headerName: 'Uploaded On',
      sortable: true,
      width: 165,
      valueGetter: params => moment(params.row.created_on).format('MM/DD/YYYY'),
    },
    {
      field: 'effective',
      headerName: 'Effective As Of',
      sortable: true,
      width: 165,
      valueGetter: params => moment(params.row.effective_date).format('MM/DD/YYYY'),
    },

    {
      headerName: '',
      field: 'preview',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Preview" arrow placement="top">
            {/* <img src={findInImgIcon} alt="preview" /> */}

            <FindIcon onClick={() => onPreviewDocument(row)} />
          </Tooltip>
        )
      },
    },

    {
      renderHeader: function () {
        return selectedDocuments.length ? (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Share" arrow placement="top">
            {/* <img src={shareIcon} onClick={() => onShareDocuments(false)} alt="share all" /> */}
            <ShareVaultIcon onClick={() => onShareDocuments(false)} />
          </Tooltip>
        ) : (
          <Tooltip
            componentsProps={{ tooltip: { sx: sx.tooltip } }}
            title="Please select document"
            arrow
            placement="top"
          >
            {/* <img src={shareIcon} alt="share all" /> */}
            <ShareVaultIcon />
          </Tooltip>
        )
      },
      field: 'share',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Share" arrow placement="top">
            {/* <img src={shareIcon} onClick={() => onShareDocuments(row.t_vault_article_id)} alt="share" /> */}
            <ShareVaultIcon onClick={() => onShareDocuments(row.t_vault_article_id)} />
          </Tooltip>
        )
      },
    },

    {
      renderHeader: function () {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Delete" arrow placement="top">
            {/* <img src={deleteIcon} alt="delete" onClick={onRemoveDocuments} /> */}
            <DeleteIcon onClick={onRemoveDocuments} />
          </Tooltip>
        )
      },
      field: 'delete',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Delete" arrow placement="top">
            {/* <img src={deleteIcon} onClick={() => onRemoveDocument(row.t_vault_article_id)} alt="delete" /> */}
            <DeleteIcon onClick={() => onRemoveDocument(row.t_vault_article_id)} />
          </Tooltip>
        )
      },
    },
  ]

  const onPreviewDocument = document => {
    const operation = 'previewed'
    VaultAPI.submitDocumentHistory(vaultInfo.vault_id, document.t_vault_article_id, operation)
    setSelectedPreview(document)
    setPreviewDialog(true)
  }

  const onRemoveDocument = documentId => {
    setSelectedToRemove([documentId])
    setShowRemoveConfirmPopup(true)
  }

  const removeDocument = () => {
    setShowRemoveConfirmPopup(false)
    setSelectedDocuments([])
    VaultAPI.removeDocuments(dispatch, vaultInfo.vault_id, selectedToRemove)
  }

  const onAddDocumpent = () => {
    //NOTE: This will be showing uploading popup check src/components/vault/VaultAddDocumentPopUp.js
    setShowAddDocumentPopup(!showAddDocumentPopup)
  }

  const onShareDocuments = Id => {
    if (documents && documents.length < 1) {
      return
    }
    setDatum(Id)
    setShowSharePopup(true)
  }

  const handleCheckBox = () => {
    setSelectedDocuments([])
  }

  const onRemoveDocuments = () => {
    if (selectedDocuments.length > 0) {
      setShowRemoveConfirmPopup(true)
      setSelectedToRemove(selectedDocuments)
    }
  }

  function handleSelectionModelChange(ids) {
    setSelectedDocuments(ids)
  }

  return (
    <div className="vault-documents">
      <div className="vault-documents-table-wrapper">
        {(loadingDocuments || loadingVaultSummary) && (
          <LoadingOverlay
            style={{
              top: '4rem',
              height: 'calc(100% - 4rem)',
              fontSize: '6rem',
            }}
          />
        )}
        <Box sx={sx.tableBox}>
          <DataGrid
            headerHeight={40}
            rowHeight={80}
            sx={sx.table}
            getRowId={row => row.t_vault_article_id}
            rows={documents}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableColumnMenu={true}
            checkboxSelection
            selectionModel={selectedDocuments}
            onSelectionModelChange={handleSelectionModelChange}
            components={{
              ColumnUnsortedIcon: UnfoldMoreIcon,
            }}
            disableSelectionOnClick={true}
          />
        </Box>
      </div>
      <Box sx={{ marginTop: '40px' }}>
        <Button type={PRIMARY_BUTTON} onClick={onAddDocumpent}>
          <span className="text-bold">Add documents</span>
        </Button>
      </Box>
      {showAddDocumentPopup && (
        <VaultAddDocumentPopUp
          onClose={() => {
            setShowAddDocumentPopup(!showAddDocumentPopup)
            dispatch({ type: actionTypes.VAULTDRAFTDOCUMENTSRESET })
          }}
        />
      )}
      {showRemoveConfirmPopup && (
        <ConfirmDialog
          show={showRemoveConfirmPopup}
          setShow={() => setShowRemoveConfirmPopup(false)}
          onSuccess={removeDocument}
          SuccessMessage="Delete"
          title="Are You Sure?"
          content={
            <Typography sx={{ marginX: '25px' }}>
              Do you want to proceed with removing the document(s) from the Vault?
            </Typography>
          }
        />
      )}
      {previewDialog && (
        <VaultDocumentPreviewPopup
          document={selectedPreview}
          vault_id={vaultInfo.vault_id}
          onClose={() => setPreviewDialog(false)}
        />
      )}
      {showSharePopup && (
        <Dialog width="570px" onClose={() => setShowSharePopup(false)}>
          <ShareModal
            data={{
              selectedId: selectedDocuments,
              secShareType: 'article',
            }}
            docs={documents}
            datam={selectedDatum}
            callBack={handleCheckBox}
            vaultInfo={vaultInfo}
            onClose={() => {
              setShowSharePopup(false)
            }}
          />
        </Dialog>
      )}
    </div>
  )
}

export default VaultDocuments
